import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { formatDate, formatDateTime, formatFull, toDate } from "../dates";
import { CoachingCultureColorName } from "../theme";
import Label from "./Label";
import Text from "./Text";

export type DatePillProps = {
  value: Date | number | null | undefined;
  color?: CoachingCultureColorName;
  dangerIfEmpty?: boolean;
  dateOnly?: boolean;
};

export const DatePill = ({
  value,
  color = "grey2",
  dangerIfEmpty = false,
  dateOnly = false,
}: DatePillProps) => {
  const asDate = value == null ? null : toDate(value);

  const col = dangerIfEmpty && value == null ? "danger" : color;

  return (
    <Label
      icon={FaCalendarAlt}
      color={col}
      size="small"
      title={asDate == null ? undefined : formatFull(asDate, !dateOnly)}
    >
      <Text as="span" fontWeight={500} color="inherit">
        {asDate == null
          ? "Never"
          : dateOnly
            ? formatDate(asDate)
            : formatDateTime(asDate)}
      </Text>
    </Label>
  );
};
